import React, {useRef} from 'react'
import AppState from "../../../../domain/contexts/AppState"
import {Config} from "../../../../domain/config/Config"
import css from './LangSwitcher.module.css'
import LIcon from "../../lui/data/icon/LIcon"
import LFlex from "../../lui/layout/lflex/LFlex"
import {observer} from "mobx-react"


function LangSwitcher(){

    const ref = useRef()
    const appState = AppState.instance

    const setLang = (val) => {
        appState.setLang(val)
        // unhover animation
        setTimeout( ()=>{
            ref.current.classList.add(css.containerUnhover)
        }, 50 )
        setTimeout( ()=>{
            ref.current.classList.remove(css.containerUnhover)
        }, 250 )
    }

    const list = Config.langsAllowed.map( (val, index) => (
        <li key={index}
            onClick={ () => setLang(val) }
        >{val}</li>
    ))

    return (
        <div className={css.container} ref={ref}>
            <LFlex className={css.current + ' ai-center' }>
                <LIcon name='language' size='2' color='grey' />
                <span>{appState.lang}</span>
            </LFlex>
            <ul>{list}</ul>
        </div>
    );

}

export default observer(LangSwitcher)

